import React, { useState } from "react";
import { ArrowUp } from "lucide-react";

export default function ChatComposer({ onSend, disabled, placeholder }) {
    const [text, setText] = useState("");
    const send = () => {
        const q = text.trim();
        if (!q || disabled) return;
        onSend(q);
        setText("");
    };
    return (
        <div className="border-t border-white/10 p-4 bg-[#050505]">
            <div className="flex items-end gap-2 bg-[#0a0a0a] border border-white/15 rounded-lg px-3 py-2 focus-within:border-white/30 transition-colors">
                <textarea value={text} onChange={(e) => setText(e.target.value)} rows={2} maxLength={4000} disabled={disabled}
                    onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
                    placeholder={placeholder} data-testid="ask-input"
                    className="flex-1 bg-transparent resize-none text-sm focus:outline-none placeholder:text-white/30 disabled:opacity-50" />
                <button onClick={send} disabled={disabled || !text.trim()} data-testid="ask-send" title="Ask"
                    className="p-2 rounded-md bg-[#7C3AED] text-white hover:bg-[#6D28D9] disabled:bg-white/10 disabled:text-white/30 transition-colors">
                    <ArrowUp className="w-4 h-4" />
                </button>
            </div>
            <div className="text-[10px] text-white/30 mt-1.5 font-mono">Enter to ask · Shift+Enter for a new line · read-only, at most 15 lookups per answer</div>
        </div>
    );
}
